import { Ref, ref } from "vue";
import { SyainService } from "@/service/SyainService";
import { DetailInputData, DetailData } from "@/types/Syain";
import { FormUtil } from "@/utils/FormUtil";
import { AxiosError } from "axios";
import { DialogService } from "@/service/DialogService";
import { useForm } from '@/composable/form/form';

/*
 * 登録処理
 */
export function useCreate() {
  const isCreating = ref(false)
  const { removeAllError } = useForm()

  // 入力内容を更新する
  const create = async (form: Ref<DetailInputData>): Promise<number | null> => {

      isCreating.value = true
      // エラーなしの場合
      let returnVal: number | null
      // 更新処理
      const srv = new SyainService();

      return srv.create(form.value).then(res => {
        DialogService.success({
          text: '登録しました！'
        })
        returnVal = res
      }).catch(e => {
        // Formの入力エラーをリセット
        removeAllError(form.value)
        
        const err = e as AxiosError<any>
        FormUtil.setLaravelError(form.value, err)
        returnVal = null
      }).then(() => {
        /* --- finaly処理 --- */
        // 更新中フラグを解除
        isCreating.value = false
        return returnVal
      })
  }

  return {
    isCreating,
    create,
  }
}
